/* eslint-disable no-template-curly-in-string */
import * as Yup from 'yup'
import { VALIDATION_KEYS } from '../utils/translation-constants'
import validationConfig from 'custom/config/validation.config.json'
import config from "custom/config/environment"
const chequeBookConfig = validationConfig['OtherService']['chequeBook']
const stopChequeConfig = validationConfig['OtherService']['stopCheque']
const siConfig = validationConfig['OtherService']['standingInstructions']
const approvalConfig = validationConfig['approval']
const chequeStatusConfig = validationConfig['OtherService']['chequeStatus']
const cardRequestConfig = validationConfig['cardRequest']
const blockCardConfig = validationConfig['blockCard']


import moment from 'moment'

const validateChequeBookPickUpBranch = chequeBookConfig['pickUpBranch']
  ? {
      pickUpBranch: Yup.string().required(VALIDATION_KEYS.PICK_UP_BRANCH_REQUIRED),
    }
  : {
      pickUpBranch: Yup.string().optional(),
    }

const validateChequeBookNoOfLeaves = chequeBookConfig['numberOfLeaves']
  ? {
      numberOfLeaves: Yup.string().required(VALIDATION_KEYS.NO_OF_LEAVES_REQUIRED),
    }
  : {
      numberOfLeaves: Yup.string().optional(),
    }

const validateChequeBookNoOfBooks = chequeBookConfig['numberOfBooks']
  ? {
    noOfChequeBooks: Yup.string().required(VALIDATION_KEYS.NO_OF_BOOKS_REQUIRED),
    }
  : {
    noOfChequeBooks: Yup.string().optional(),
    }

const validateChequeNo = stopChequeConfig['isChequeNumberRequired']
  ? {
      chequeNumber: Yup.string()
        .matches(new RegExp('^[0-9]{6,10}$'), VALIDATION_KEYS.CHEQUE_NO_MIN_MAX)
        .when('rangeOfCheques', {
          is: 'INDIVIDUAL',
          then: Yup.string()
            .matches(new RegExp('^[0-9]{6,10}$'), VALIDATION_KEYS.CHEQUE_NO_MIN_MAX)
            .required(VALIDATION_KEYS.CHEQUE_NO_REQUIRED),
          otherwise: Yup.string(),
        }),
    }
  : {
      chequeNumber: Yup.string().optional(),
    }

const validateStartChequeNo = stopChequeConfig['isStartChequeNoRequired']
  ? {
      startChequeNumber: Yup.string()
        .matches(new RegExp('^[0-9]{6,10}$'), VALIDATION_KEYS.CHEQUE_NO_MIN_MAX)
        .when('rangeOfCheques', {
          is: 'RANGE',
          then: Yup.string()
            .matches(new RegExp('^[0-9]{6,10}$'), VALIDATION_KEYS.CHEQUE_NO_MIN_MAX)
            .required(VALIDATION_KEYS.START_CHEQUE_NO_REQUIRED),
          otherwise: Yup.string(),
        }),
    }
  : {
      startChequeNumber: Yup.string().optional(),
    }

const validateEndChequeNo = stopChequeConfig['isEndChequeNoRequired']
  ? {
      endChequeNumber: Yup.string()
        .matches(new RegExp('^[0-9]{6,10}$'), VALIDATION_KEYS.CHEQUE_NO_MIN_MAX)
        .when('rangeOfCheques', {
          is: 'RANGE',
          then: Yup.string()
            .matches(new RegExp('^[0-9]{6,10}$'), VALIDATION_KEYS.CHEQUE_NO_MIN_MAX)
            .required(VALIDATION_KEYS.END_CHEQUE_NO_REQUIRED),
          otherwise: Yup.string(),
        }),
    }
  : {
      endChequeNumber: Yup.string().optional(),
    }

const validateEffectiveDate = stopChequeConfig['isEffectiveDateRequired']
  ? {
      effectiveDate: Yup.date()
        // .min(new Date(), 'Effective Date should be greater than today')
        .required(VALIDATION_KEYS.EFFECTIVE_DATE_REQUIRED),
    }
  : {
      effectiveDate: Yup.date().optional(),
    }

const validateReason = stopChequeConfig['isReasonRequired']
  ? {
      reason: Yup.string().required(VALIDATION_KEYS.REASON_REQUIRED),
    }
  : {
      reason: Yup.string().optional(),
    }

const validateRemark = stopChequeConfig['isRemarksRequired']
  ? {
      remarks: Yup.string()
        .min(2, VALIDATION_KEYS.REMARKS_MIN_MAX)
        .max(40, VALIDATION_KEYS.REMARKS_MIN_MAX)
        .required(VALIDATION_KEYS.REMARKS_REQUIRED),
    }
  : {
      remarks: Yup.string().optional(),
    }

const validateRequestType = siConfig['isRequestTypeRequired']
  ? {
      requestType: Yup.string().required(VALIDATION_KEYS.REQUEST_TYPE_REQUIRED),
    }
  : {
      requestType: Yup.string().optional(),
    }

const validateAccountNo = siConfig['isAccountNoRequired']
  ? {
      creditAccountNumber: Yup.string()
        .min(config.ACC_NO_LENGTH, VALIDATION_KEYS.ACCOUNT_NO_DIGIT)
        .required(VALIDATION_KEYS.CREDIT_ACCOUNT_NO_REQUIRED),
    }
  : {
      creditAccountNumber: Yup.string().optional(),
    }
const validateStartDate = siConfig['isStartDateRequired']
  ? {
      startDate: Yup.date()
        .required(VALIDATION_KEYS.START_DATE_REQUIRED),
    }
  : {
      startDate: Yup.date().optional(),
    }

const validateEndDate = siConfig['isEndDateRequired']
  ? {
      endDate: Yup.date()
        .min(Yup.ref('startDate'), VALIDATION_KEYS.END_DATE_GREATER_START_DATE)
        .required(VALIDATION_KEYS.END_DATE_REQUIRED)
        .test({
          name: "same",
          exclusive: false,
          params: {},
          message: VALIDATION_KEYS.END_DATE_GREATER_START_DATE,
          test: function(value) {
            const startDate = moment(this.parent.startDate).format("YYYY-MM-DD")
            const endDate = moment(value).format("YYYY-MM-DD")
            return !moment(startDate).isSame(moment(endDate))
          },
        }),
    }
  : {
      endDate: Yup.date().optional(),
    }

const validateSIAmount = siConfig['isAmountRequired']
  ? {
      siAmount: Yup.string()
        // .matches(new RegExp('^[red1-9][0-9]*$'), 'Instant transfer should not start with 0')
        .required(VALIDATION_KEYS.AMOUNT_REQUIRED),
    }
  : {
      siAmount: Yup.string().optional(),
    }

const validateRemarks = siConfig['isRemarksRequired']
  ? {
      remarks: Yup.string()
        .min(2, VALIDATION_KEYS.REMARKS_MIN_MAX)
        .max(40, VALIDATION_KEYS.REMARKS_MIN_MAX)
        .required(VALIDATION_KEYS.REMARKS_REQUIRED),
    }
  : {
      remarks: Yup.string().optional(),
    }

const validateComments = approvalConfig['isCommentRequired']
  ? {
      comments: Yup.string().required(VALIDATION_KEYS.COMMENTS_REQUIRED),
    }
  : {
      comments: Yup.string().optional(),
    }

const validateCardRequestAccountNo = cardRequestConfig["isAccountNoRequired"]
  ? {
    accountNo: Yup.string().required(VALIDATION_KEYS.ACCOUNT_NO_REQUIRED),
  }
  : {
    accountNo: Yup.string().optional(),
  };

const validateCardRequestCardProducts = cardRequestConfig["isCardProductRequired"]
  ? {
    cardProducts: Yup.string().required(VALIDATION_KEYS.CARD_PRODUCTS_REQUIRED),
  }
  : {
    cardProducts: Yup.string().optional(),
  };

const validateCardRequestDeliveryBranch = cardRequestConfig["isBranchRequired"]
  ? {
    deliveryBranch: Yup.string().when('deliveryMode', {
      is: 'BRANCH',
      then: Yup.string().required(VALIDATION_KEYS.BRANCH_NAME_REQUIRED),
      otherwise: Yup.string().optional(),
    }),
  }
  : {
    deliveryBranch: Yup.string().optional(),
  };


const validateCardRequestRequestType = cardRequestConfig["isRequestTypeRequired"]
  ? {
    requestType: Yup.string().required(VALIDATION_KEYS.REQUEST_TYPE_REQUIRED),
  }
  : {
    requestType: Yup.string().optional(),
  };
    
  
    

export const ChequeBookRequestSchema = Yup.object().shape({
  // accountNum: Yup.string().required('Account Number Required'),
  ...validateChequeBookPickUpBranch,
  ...validateChequeBookNoOfLeaves,
  ...validateChequeBookNoOfBooks
})

const ValidateChequeNumber = chequeStatusConfig['isChequeNoRequired']
  ? {
      chequeNumber: Yup.string()
        .required(VALIDATION_KEYS.CHEQUE_NUMBER_REQUIRED)
        .matches(new RegExp(config.CHEQUE_NO_LENGTH), VALIDATION_KEYS.CHEQUE_NUMBER_LENGTH),
    }
  : {
      chequeNumber: Yup.string().optional(),
    }

export const ChequeStatusSchema = Yup.object().shape({
  ...ValidateChequeNumber
  // accountNumber: Yup.string().required('Account Number Required'),
  // chequeNumber: Yup.string()
  //   .required(VALIDATION_KEYS.CHEQUE_NO_REQUIRED)
  //   .matches(new RegExp('^[0-9]{6,10}$'), VALIDATION_KEYS.CHEQUE_NO_MIN_MAX),
})

export const StopChequePaymentSchema = Yup.object().shape({
  rangeOfCheques: Yup.string(),
  // accountNumber: Yup.string().required('Account Number Required'),
  ...validateChequeNo,
  ...validateStartChequeNo,
  ...validateEndChequeNo,
  ...validateEffectiveDate,
  ...validateReason,
  ...validateRemark,
})

const validateBlockCardRemark = blockCardConfig['isRemarksRequired']
  ? {
    remarks: Yup.string()
      .required(VALIDATION_KEYS.REMARKS_REQUIRED),
  }
  : {
    remarks: Yup.string().optional(),
  }

const ValidateCardNumber = blockCardConfig['isCardNoRequired']
  ? {
    cardNumber: Yup.string()
      .required(VALIDATION_KEYS.CARD_NUMBER)
  }
  : {
    cardNumber: Yup.string().optional(),
  }


export const BlockDebitCardSchema = Yup.object().shape({
  ...validateBlockCardRemark,
  ...ValidateCardNumber,
})

export const CardLoadSchema = Yup.object().shape({
  // accountNumber: Yup.string().required('Account Number Required'),
  cardNumber: Yup.string()
    .matches(new RegExp('^[0-9]*$'), 'Numbers Only')
    .required('Card Number is required'),
  currency: Yup.string(),
  amount: Yup.string().required('Amount is required'),
})

export const ChangeCardPINSchema = Yup.object().shape({
  // accountNumber: Yup.string().required('Account Number Required'),
  cardNumber: Yup.number().required('Card Number is required'),
  expiryMonth: Yup.string().required('Expiry Month is required'),
  expiryYear: Yup.string().required('Expiry Year is required'),
  oldPin: Yup.string()
    .required('Old Pin is required')
    .matches(new RegExp('^[0-9]{4}$'), 'Pin Number invalid '),
  newPin: Yup.string()
    .matches(new RegExp('^[0-9]{4}$'), 'Pin Number invalid')
    .required('New Pin is required'),
  confirmNewPin: Yup.string()
    .oneOf([Yup.ref('newPin'), null], 'Pin not matching')
    .required('Confirm Pin is required'),
})

export const CreateStandingInstructionSchema = Yup.object().shape({
  ...validateRequestType,
  // debitAccountNumber: Yup.string().required('Debit Account Number Required'),
  ...validateAccountNo,
  ...validateStartDate,
  ...validateEndDate,
  ...validateSIAmount,
  ...validateRemarks,
  date: Yup.number().when('monthEndFlag', {
    is: false,
    then: Yup.number().max(30, VALIDATION_KEYS.INVALID_DATE),
    otherwise: Yup.number(),
  }),
  // month: Yup.number().when('monthEndFlag', {
  //   is: false,
  //   then: Yup.number()
  //     .max(11, 'Invalid Month'),
  //   otherwise: Yup.number(),
  // }),
  // year: Yup.number(),
  // siAmount: Yup.string().required('SI Amount required'),
  // remarks: Yup.string()
  // .min(4, 'Minimuim 4 Characters')
  // .required('Remarks required'),
  // monthEndFlag: Yup.boolean(),
  // oneOfDMY: Yup.bool().when(['date', 'month', 'year', 'monthEndFlag'], {
  //   is: (date, month, year, monthEndFlag) =>
  //     monthEndFlag !== true && ((!date && !month && !year) || (!!date && !!month && !!year)),
  //   then: Yup.bool().required('One of Date,Month,Year Needed'),
  //   otherwise: Yup.bool(),
  //}),
})

export const ApprovalSchema = Yup.object().shape({
  ...validateComments,
})

export const CardRequestSchema = Yup.object().shape({
  ...validateCardRequestAccountNo,
  ...validateCardRequestCardProducts,
  ...validateCardRequestDeliveryBranch,
  ...validateCardRequestRequestType,
})

